import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import api from '../../axios';
import AuthenticatedLayout from '../../Layouts/AuthenticatedLayout';
import InputLabel from '../../Components/InputLabel';
import TextInput from '../../Components/TextInput';
import InputError from '../../Components/InputError';
import PrimaryButton from '../../Components/PrimaryButton';
import { useAuth } from "../../context/AuthContext";
import { Button } from '../../shadcn/ui/button';

export default function NewUser() {
  const [data, setData] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { user } = useAuth(); // Fetch authenticated user from context

  const submit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/register', data);
      // Display success message from server response
      const successMessage = response.data.message || 'Registration successful!';
      alert(successMessage); // Display success message (you can replace this with your own notification system)
      setData({
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      });
      setErrors({});
      navigate('/');
    } catch (err) {
      setErrors(err.response.data.errors || {});
    }
  };

  return (
    <AuthenticatedLayout user={user}>
      <div className="max-w-lg mx-auto mt-10 p-6 bg-white shadow rounded-lg">
        <h1 className="text-2xl font-bold mb-6 text-center">Νέο Χρήστη</h1>
        <form onSubmit={submit}>
          {/* Name Input */}
          <div className="mb-4">
            <InputLabel htmlFor="name" value="Όνομα" />
            <TextInput
              id="name"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
              value={data.name}
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />
            <InputError message={errors.name} />
          </div>

          {/* Email Input */}
          <div className="mb-4">
            <InputLabel htmlFor="email" value="Email" />
            <TextInput
              id="email"
              type="email"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
              value={data.email}
              onChange={(e) => setData({ ...data, email: e.target.value })}
            />
            <InputError message={errors.email} />
          </div>

          {/* Password Input */}
          <div className="mb-4">
            <InputLabel htmlFor="password" value="Κωδικός" />
            <TextInput
              id="password"
              type="password"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
              value={data.password}
              onChange={(e) => setData({ ...data, password: e.target.value })}
            />
            <InputError message={errors.password} />
          </div>

          {/* Password Confirmation Input */}
          <div className="mb-4">
            <InputLabel htmlFor="password_confirmation" value="Επιβεβαίωση κωδικού" />
            <TextInput
              id="password_confirmation"
              type="password"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
              value={data.password_confirmation}
              onChange={(e) => setData({ ...data, password_confirmation: e.target.value })}
            />
            <InputError message={errors.password_confirmation} />
          </div>

          {/* Submit Button */}
          <div className="flex justify-center">
            <Button type="submit">
              Εγγραφή
            </Button>
          </div>
        </form>
      </div>
    </AuthenticatedLayout>
  );
}
